import find from 'lodash/find';
import startCase from 'lodash/startCase';
import uniqBy from 'lodash/uniqBy';
import React, { Fragment, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { Flex, Text } from 'roo-ui/components';
import { Grid } from './primitives';
import Filters from './Filters';
import Deal from './Deal';
import { useDataLayer } from 'hooks/useDataLayer';
import { getMerchandise } from 'store/destination/destinationSelectors';

const NoAvailableDeals = () => (
  <Flex alignItems="center" justifyContent="center" py={2}>
    <Text fontSize="base" data-testid="no-offers">
      Sorry, we currently have no offers in this area.
    </Text>
  </Flex>
);

const DealsSlider = () => {
  const merchandise = useSelector(getMerchandise);
  const { emitInteractionEvent } = useDataLayer();
  const [filter, setFilter] = useState('popular');

  const properties = getProperties({ merchandise, filter });
  const filters = buildFilters(merchandise);

  const handleFilterChange = useCallback(
    (selection) => {
      const { label, value } = find(filters, ['value', selection]);

      setFilter(value);
      emitInteractionEvent({ type: 'Latest Deals Navigation', value: `${startCase(label)} Selected` });
    },
    [filters, emitInteractionEvent],
  );
  const hasDeals = properties && properties.length > 0;

  return (
    <Fragment>
      {filters && <Filters onChange={handleFilterChange} items={filters} value={filter} />}
      {hasDeals ? (
        <Fragment>
          <Grid>
            {properties.map((property, index) => (
              <Deal key={`property-${index}`} {...property} />
            ))}
          </Grid>
        </Fragment>
      ) : (
        <NoAvailableDeals />
      )}
    </Fragment>
  );
};

const buildFilters = ({ subRegions }) => {
  if (subRegions) {
    const items = [{ label: 'Popular', value: 'popular' }];

    for (const subRegion of subRegions) {
      items.push({ label: subRegion.regionName, value: subRegion.regionId });
    }

    /**
     * NOTE: We have to add this in due to the merchandising API
     * occasionally returning duplicate sub regions.
     *
     * We can remove this step if/when they filter duplicates.
     */
    const uniqueItems = uniqBy(items, 'label');

    return uniqueItems;
  }
};

const getProperties = ({ filter, merchandise }) => {
  if (filter === 'popular') {
    return merchandise?.properties;
  } else {
    const subRegion = find(merchandise?.subRegions, ['regionId', filter]);

    return subRegion?.properties;
  }
};

export default DealsSlider;
